import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { hrAeAction } from '../actions/hrActions'
import Notification from '../components/Notification'
import Progress from '../components/Progress'
import PageHeader from '../components/PageHeader'
import PeopleOutlineTwoToneIcon from '@material-ui/icons/PeopleOutlineTwoTone'
import MaterialTable from 'material-table'
import { HR_ASEG_RESET } from '../constants/hrConstants'

const headCells = [
  {
    field: 'employeeCode',
    title: 'Employee Code',
    render: (rowData) => (
      <a href={`/hr/employee/${rowData.id}`} target='_blank'>
        {rowData.employeeCode}
      </a>
    ),
  },
  {
    field: 'name',
    title: 'Employee Name',
  },
  {
    field: 'organisation',
    title: 'Organisation',
  },
  {
    field: 'mobile',
    title: 'Mobile',
  },
  {
    field: 'department',
    title: 'Department',
  },
  {
    field: 'emailAddress',
    title: 'Email Address',
  },
  {
    field: 'doj',
    title: 'Date of Joining',
  },
]

const HRActiveEmployees = ({ history }) => {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })

  const dispatch = useDispatch()
  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const hrAe = useSelector((state) => state.hrAe)
  const { loading, error, hrActiveEmployees } = hrAe

  useEffect(() => {
    if (!userInfo) {
      history.push('/')
    }
  }, [dispatch, history, userInfo])

  const [activeEmployees, setActiveEmployees] = useState([])

  useEffect(() => {
    dispatch(hrAeAction())
  }, [])

  useEffect(() => {
    // dispatch({ type: HR_ASEG_RESET })
    if (hrActiveEmployees) {
      if (
        hrActiveEmployees.role === 'Admin' ||
        hrActiveEmployees.role === 'HR'
      ) {
        setActiveEmployees(hrActiveEmployees.employees)
      } else {
        history.push('/dashboard')
      }
    } else if (error) {
      setNotify({
        isOpen: true,
        message: error,
        type: 'error',
      })
    }
  }, [hrActiveEmployees, error])

  return (
    <div>
      {loading ? (
        <Progress />
      ) : (
        <>
          {error ? (
            <Notification notify={notify} setNotify={setNotify} />
          ) : (
            <>
              <PageHeader
                title='Active Employees'
                subtitle='Shows list of active employees working in the organisations'
                icon={<PeopleOutlineTwoToneIcon fontSize='medium' />}
              />
              <MaterialTable
                style={{ margin: '0 20px' }}
                title='Active Employees'
                columns={headCells}
                data={activeEmployees}
                options={{
                  exportButton: true,
                  search: true,
                  exportAllData: true,
                }}
              />
            </>
          )}
        </>
      )}
    </div>
  )
}

export default HRActiveEmployees
